import React, { useState } from "react";
import {
  Modal,
  Input,
  Button,
  List,
  Typography,
  Space,
  Divider,
  message,
} from "antd";
import axiosInstance from "../../configs";

const { Text } = Typography;

const TrackingModal = ({ open, onClose }) => {
  const [nomorDaftar, setNomorDaftar] = useState("");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!nomorDaftar) {
      message.warning("Mohon isi Nomor Pendaftaran");
      return;
    }
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/portal/pasifik/tracking/${nomorDaftar}`);
      const data = response.data;
      // API returns array of respon objects
      setResponseData(Array.isArray(data) ? data : []);
      if (!data || data.length === 0) {
        message.info("Tidak ada data ditemukan.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Gagal mengambil data tracking.");
      setResponseData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <div
          style={{
            background: "#f5f9fc",
            margin: "-24px -24px 16px -24px",
            padding: "16px 24px",
            borderBottom: "1px solid #e9ecef",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <span style={{ fontSize: "18px", fontWeight: 600, color: "#2c3e50" }}>
            Tracking Dokumen Pabean
          </span>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <Space direction="vertical" style={{ width: "100%", marginTop: 10 }} size="middle">
        <Input
          placeholder="Masukkan Nomor Pendaftaran"
          value={nomorDaftar}
          onChange={(e) => setNomorDaftar(e.target.value)}
          onPressEnter={handleSearch}
        />

        <Divider />

        {responseData.length > 0 ? (
          <List
            itemLayout="horizontal"
            dataSource={responseData}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={<Text strong>Kode Respon: {item.kode_respon}</Text>}
                  description={
                    <>
                      <Text type="secondary">Waktu: {item.tanggal_respon} {item.waktu_respon}</Text>
                      <br />
                      {/* <Text>{item.uraian}</Text> Display uraian if available */}
                    </>
                  }
                />
              </List.Item>
            )}
          />
        ) : (
          <Text type="secondary">Belum ada hasil pencarian.</Text>
        )}

        <Divider />

        <Space style={{ justifyContent: "end", width: "100%" }}>
          <Button onClick={onClose}>Kembali</Button>
          <Button
            type="primary"
            icon={<i className="flaticon2-search" />}
            onClick={handleSearch}
            loading={loading}
          >
            Cari
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};

export default TrackingModal;
